module.exports = __webpack_public_path__ + "static/media/surfing_tiny.feaf045f.webp";